import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from "@mui/material";
import Swal from "sweetalert2";
import {
  companyManagementUrl,
  customerservice,
  loanManagementUrl,
  setupManagementUrl,
} from "../../config";
import {
  executeAnyMutation,
  fetchJson,
  fetchJsonDynamic,
} from "../../data/DynamicServiceNew/jsondynamicservice";
import CustomerModal from "./CustomerListModal";
import { useTheme } from "@emotion/react";
import { tokens } from "../../theme";
import { CircularProgress } from "@mui/material";


const BookGroupLoan = () => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  const companyId = parseInt(decodedToken.CompanyId);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredGroup, setFilteredGroup] = useState(null);
  const [amount, setAmount] = useState("");
  const [loanProductSelected, setLoanProductSelected] = useState([]);
  const [loanProduct, setLoanProduct] = useState("");
  const [customers, setCustomers] = useState("");
  const [open, setOpen] = useState(false);
  const [GroupData, setGroupData] = useState([]);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [branchData, setBranchData] = useState("");
  const [totalLoanLimit, setTotalLoanLimit] = useState("");
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const handleOpen = () => setOpen(true);

  const resetForm = () => {
    setSearchTerm("");
    setFilteredGroup(null);
    setAmount("");
    setLoanProductSelected("");
  };
  useEffect(() => {
    const fetchData = async () => {
      const groupResponse = await fetchJsonDynamic(
        "allGroupsView",
        null,
        null,
        customerservice.uri
      );
      const allGroups = JSON.parse(groupResponse?.results) || [];

      const params = {companyId: companyId};
      const productResponse = await fetchJsonDynamic(
        "groupProducts",
        "parameters",
        params,       
        setupManagementUrl.uri
      );
      const products = JSON.parse(productResponse.results) || [];
      // const filteredProducts = products.filter(product => product.IsGroup === true);
      // Filter regions based on selected company ID
      setGroupData(allGroups);
      setLoanProduct(products);
    };
    fetchData();
  }, []);
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchTerm) {
        setLoadingSearch(true); // Start loading indicator
        
        if (searchTerm.length >= 1) {
          const fetchGroupData = async () => {
            try {
              const params = { code: searchTerm }; // Use GroupCode as input
              const groupResponse = await fetchJsonDynamic(
                "groupsByColumnValues",
                "group",
                params,
                customerservice.uri
              );
  
              const group = JSON.parse(groupResponse?.results)[0] || null;
  
              if (group) {
                setFilteredGroup(group);
                
                // Fetch customers under this group
                const customerParams = { groupId: group.Id };
                const customerByGroup = await fetchJson({
                  objectName: "customerGroupViewByColumnValues",
                  inputObjectName: "customerGroupView",
                  params: customerParams,
                  baseUrl: customerservice.uri,
                });
  
                setCustomers(JSON.parse(customerByGroup.results) || []);
              } else {
                Swal.fire("Group Not Found", "Group does not exist", "warning");
                setFilteredGroup(null);
              }
            } catch (error) {
              Swal.fire("Error", "Failed to fetch group data", "error");
            } finally {
              setLoadingSearch(false);
            }
          };
  
          fetchGroupData();
        }
      } else {
        // Reset state if searchTerm is empty
        setFilteredGroup(null);
        setLoadingSearch(false);
      }
    }, 1000); // Adjust debounce delay as needed
  
    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);
    useEffect(() => {
      const fetchBranches = async () => {
        try {
          const branchDataResponse = await fetchJsonDynamic(
            "branch",
            null,
            null,
            companyManagementUrl.uri
          );
          if (branchDataResponse?.results) {
            const results = JSON.parse(branchDataResponse.results);
            setBranchData(results || []);
          }
        } catch (error) {
          console.error("Error fetching branch data:", error);
          Swal.fire("Error", "Failed to fetch branch data.", "error");
        }
      };
  
      fetchBranches();
    }, []);
    const getBranchName = (branchId) => {
      const branch = branchData?.find((branch) => branch.Id === branchId || "");
      return branch ? branch.Name : "Unknown Branch"; // Fallback to "Unknown Branch" if not found
    };
  
  

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

 
  const handleAppraisalSubmit = async () => {
    try {
      const mutationData = {
        p_GroupId: filteredGroup.Id,
        p_ProductId: loanProductSelected,
      };

      const response = await executeAnyMutation(
        "insertGroupLoanApplications",
        mutationData,
        "loanApplication",
        false,
        loanManagementUrl.uri
      );
      const parsedResults = JSON.parse(response.results);
      if (parsedResults) {
        if (parsedResults === "Loan Booked Successfully") {
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: parsedResults,
          });
          // Reset form upon successful submission
          resetForm();
        } else {
          Swal.fire({
            icon: "error",
            title: "Error!",
            text: parsedResults,
          });
        }
      } else if (response.errors) {
        throw new Error(
          response.errors[0].Error || "An internal server error occurred."
        );
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
      // Reset form upon successful submission
      resetForm();
    }
  };
  const formatDate = (date) => {
    if (!date) return null; // Handle null or undefined dates
    return date.split("T")[0]; // Extract the date part
  };

  return (
    <Box sx={{ padding: 4 }}>
      <Typography variant="h5">Book A Group Loan</Typography>
      <TextField
        label="Search Group by Group Code"
        placeholder="Enter Group Code"
        variant="outlined"
        fullWidth
        margin="normal"
        value={searchTerm}
        //onChange={handleSearchChange}
        onChange={(e) => setSearchTerm(e.target.value)}
                InputProps={{
                  endAdornment: loadingSearch && (
                    <CircularProgress size={24} sx={{ marginRight: 2 }} />
                  ),
                }}
      />

      {filteredGroup && (
        <>
          <Card variant="outlined" sx={{ mb: 2 }}>
            <CardContent>
              <Typography
                variant="h6"
                sx={{
                  backgroundColor: "#003049",
                  color: "white",
                  padding: "4px 8px",
                  borderRadius: 1,
                }}
              >
                Group Details
              </Typography>
              <Grid container spacing={2} sx={{ mt: 1 }}>
                 <Grid item xs={12} sm={6}>
                 <Typography>
                    <strong>Group Name:</strong> {filteredGroup.Name}
                  </Typography>
                  <Typography>
                    <strong>Mobile Number:</strong>{" "}
                    {filteredGroup.PhoneNumber}
                  </Typography>
                  <Typography>
                    <strong>Branch:</strong>{" "}
                    {getBranchName(filteredGroup.BranchId)}
                  </Typography>
                </Grid> 
                <Grid item xs={12} sm={6}>
               
                  {/* <Typography>
                    <strong>Field Officer:</strong> {filteredGroup.FirstName}{" "}
                    {filteredGroup.LastName}{" "}
                  </Typography> */}
                  <Typography>
                    <strong>Date Created:</strong>{" "}
                    {formatDate(filteredGroup.CreatedDate)}
                  </Typography>
                  <Typography>
                    <strong>Group Loan Limit:</strong>{" "}
                    {filteredGroup.LoanLimit
                      ? filteredGroup.LoanLimit.toLocaleString("en-US")
                      : "0"}
                  </Typography>
                  <Button 
                    variant="contained"
                    size="sm"
                    sx={{
                      backgroundColor: colors.greenAccent[500],
                      borderRadius: "4px",
                    }}
                  onClick={handleOpen}>
                    <Typography>View Customer List</Typography>
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          <Card variant="outlined" sx={{ mb: 2 }}>
            <CardContent>
              <Typography
                variant="h6"
                sx={{
                  backgroundColor: "#003049",
                  color: "white",
                  padding: "4px 8px",
                  borderRadius: 1,
                }}
              >
                Loan Details
              </Typography>
              <Grid container spacing={2} sx={{ mt: 1 }}>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <InputLabel>Loan Product</InputLabel>
                    <Select
                      value={loanProductSelected}
                      onChange={(e) => setLoanProductSelected(e.target.value)}
                      defaultValue=""
                    >
                      <MenuItem value="" disabled>
                        Select Loan Product
                      </MenuItem>
                      {loanProduct.map((company) => (
                        <MenuItem key={company.Id} value={company.Id}>
                          {company.Name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          <Button
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 2 }}
            onClick={handleAppraisalSubmit}
          >
            Submit For RO Appraisal
          </Button>
        </>
      )}
      {open && (
        <CustomerModal
          open={open}
          onClose={() => {
            setOpen(false);
          }}
          customerData={customers}
        />
      )}
    </Box>
  );
};

export default BookGroupLoan;
